// extracted by mini-css-extract-plugin
export default {"followPage":"FollowPage_followPage__FxUVr"};